module.exports = __webpack_public_path__ + "static/media/ade.07f1fcbc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/squadImg/ade.jpg
// module id = 717
// module chunks = 0